import { Button } from "@mantine/core";
import type { JSX } from "react";
import classes from "./QuickActionButton.module.css";

interface QuickActionButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    value: string;
    quickActionStyle?: "default" | "smartOffer";
    loading?: boolean;
}

export function QuickActionButton({
    value,
    quickActionStyle = "default",
    loading,
    ...rest
}: QuickActionButtonProps): JSX.Element {
    const isPreviewDisclosure = value.toLowerCase().includes("disclosure");
    const buttonClass = isPreviewDisclosure
        ? classes.previewDisclosureButton
        : quickActionStyle === "smartOffer"
          ? classes.smartOfferButton
          : classes.quickActionButton;

    return (
        <Button
            value={value}
            aria-label={value as string}
            className={buttonClass}
            data-testid={`QuickAction-${value as string}`}
            loading={loading}
            {...rest}
        >
            {value}
        </Button>
    );
}
